/*jshint esversion: 6 */
exports.install = function (Vue) {
    
    // 登录
    Vue.prototype.goLogin = function (url){
        var systemId     = 15;
        var locationUrl  = window.location.href;
        // locationUrl = this.relationLocationSet(locationUrl);
        window.location.href = url + 'systemId='+ systemId +'&durl='+locationUrl;
    };

    // 退出登录
    Vue.prototype.isExit = function (){
        let params = {
            token: this.getTokenFunc()
        };
        this.$axios.post(this.Common.logoutUrl, this.$qs.stringify(params))
        .then((res) => {
            let resultData = res.data;
            if(resultData.result == 0){
                this.delCookie('token');     // 删除Cookiem 清空token
                this.Common.userInfo = null; // 清空用户数据
                if(typeof this.userInfo != "undefined") this.userInfo = this.Common.userInfo;

                // 刷新页面
                this.replaceUrl("token="); // 无刷新，改变地址栏
                location.reload();
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };

    // 获取用户信息
    Vue.prototype.getAccount = function(token){
        // this.relationUrlSetting();
        this.$axios.post(this.Common.getAccountUrl, 'token='+ token)
        .then((res) => {
            let re =  res.data;
            if(re.result == 0){
                this.Common.userInfo = re.data;
            } else {
                this.delCookie('token'); // 删除Cookie
                this.Common.userInfo = null;
            }
            if(typeof this.userInfo != "undefined") this.userInfo = this.Common.userInfo;

            // 检索框提示埋点START
            this.retrievalSetting();
            // 检索框提示埋点END
        })
        .catch((err) => {
            console.log(err);
        });
    };

    // 获取token
    Vue.prototype.getTokenFunc = function(){
        // 获取Cookie中存放的token
        var token = this.getCookie("token");
        if(this.isEmpty(token)){
            token = this.getUrlParam('token');
            if(!this.isEmpty(token)){
                this.setCookie('token', token, 2); // 将token存入Cookie 0.5
                // this.replaceUrl("token="); // 无刷新，改变地址栏
            }
        }
        this.replaceUrl("token="); // 无刷新，改变地址栏
        return token;
    };

    // 获取地址栏url中的参数值
    Vue.prototype.getUrlParam = function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);    //匹配目标参数
        if (r != null) return unescape(r[2]); return null;      //返回参数值
    };

    // 获取地址栏url中的参数值(解决中文乱码)
    Vue.prototype.getZhUrlParam = function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);    //匹配目标参数
        if (r != null) return decodeURIComponent(r[2]); return null;      //返回参数值
    };

    // 设置Cookie
    Vue.prototype.setCookie = function(cname, cvalue, exhours){
        var d = new Date();
        d.setTime(d.getTime()+(exhours*60*60*1000));
        var expires = "expires="+d.toGMTString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    };

    // 获取Cookie
    Vue.prototype.getCookie = function(cname){
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) 
        {
        var c = ca[i].trim();
        if (c.indexOf(name)==0) return c.substring(name.length,c.length);
        }
        return "";
    };

    // 删除Cookie
    Vue.prototype.delCookie = function(cname){
        this.setCookie(cname, ' ', -1);
    };

    /**
     * 无刷新，改变地址栏（删除指定参数）
     * @param {String} subValue 地址栏需要截掉的参数，例：token=
     */
    Vue.prototype.replaceUrl = function(subValue){
        var newUrl = window.location.href;
        let paramIndex = newUrl.indexOf(subValue);
        if( paramIndex != -1 ){
            let _index = newUrl.indexOf("&", paramIndex+1);  // 获取该参数后面的&符号下标
            let _paramPreChar = newUrl.charAt(paramIndex-1); // 获取前一个字符
            if( _paramPreChar == '?' && _index != -1 ) _index += 1;
            else paramIndex -= 1;
            if(_index == -1) _index = newUrl.length;
            let _subStr = newUrl.substring(paramIndex, _index); 
            newUrl = newUrl.replace(_subStr, '');
            // newUrl  = newUrl.substring(0, newUrl.indexOf("?token"));
            history.replaceState(null, null, newUrl);
        }
    };

    /**
     * 无刷新，改变地址栏(从地址栏某个字符串以后删除)
     * @param {String} q 从某个字符串开始
     */
    Vue.prototype.replaceUrl2 = function(q){
        var newUrl = window.location.href;
        if( newUrl.indexOf(q) != -1 ){
            newUrl  = newUrl.substring(0, newUrl.indexOf(q));
        }
        history.replaceState(null, null, newUrl);
    };

    /**
     * 针对relation页面地址栏参数截取
     */
    Vue.prototype.relationLocationSet = function(locationUrl){
        if( locationUrl.indexOf('/relation?') != -1 ) {
            let _RELATION_URI = this.getZhUrlParam('uri');
            if(this.isEmpty(_RELATION_URI)) localStorage.removeItem('RELATION_URI');
            else localStorage.RELATION_URI = _RELATION_URI;

            let _RELATION_FROM = this.getZhUrlParam('from');
            if(this.isEmpty(_RELATION_FROM)) localStorage.removeItem('RELATION_FROM');
            else localStorage.RELATION_FROM = _RELATION_FROM;

            let _RELATION_TOKEN = this.getZhUrlParam('token');
            if(this.isEmpty(_RELATION_TOKEN)) localStorage.removeItem('RELATION_TOKEN');
            else localStorage.RELATION_TOKEN = _RELATION_TOKEN;

            locationUrl = locationUrl.substring(0, locationUrl.indexOf("?"));
        }
        return locationUrl;
    };

    /**
     * 针对relation页面的地址栏url更换
     */
    Vue.prototype.relationUrlSetting = function(){
        let locationUrl = window.location.href;
        if( locationUrl.indexOf('/relation') != -1 && locationUrl.indexOf('uri') == -1){
            let _params        = '';
            let _RELATION_URI  = localStorage.RELATION_URI;
            let _RELATION_FROM = localStorage.RELATION_FROM;
            if( locationUrl.indexOf('/relation?') != -1 ) {
                if( !this.isEmpty(_RELATION_URI) ) _params += '&uri=' + _RELATION_URI;
                if( !this.isEmpty(_RELATION_FROM) ) _params += '&uri=' + _RELATION_FROM;
            }
            else {
                if( !this.isEmpty(_RELATION_URI) ) {
                    _params = '?uri='+_RELATION_URI;
                    if( !this.isEmpty(_RELATION_FROM) ) _params+='&from='+_RELATION_FROM;
                }
                else {
                    if( !this.isEmpty(_RELATION_FROM) ) _params='?from='+_RELATION_FROM;
                }
            }
            let newUrl = locationUrl + _params;
            // locationUrl = locationUrl.substring(0, locationUrl.indexOf("?"));
            history.replaceState(null, null, newUrl);
        }
    };

    // 判断字符串是否为空
    Vue.prototype.isEmpty = function(obj){
        if(typeof obj == "undefined" || obj == null || obj == "") {
            return true;
        }
        var regu = "^[ ]+$";
        var re = new RegExp(regu);
        return re.test(obj);
    };

    // 判断数组是否为空
    Vue.prototype.isEmptyArray = function(obj){
        if(typeof obj == "undefined" || obj == null || obj.length == 0) {
            return true;
        }
        return false;
    };

    // 判断json是否为空
    Vue.prototype.isEmptyObject = function(obj){ 
        for(var key in obj){  
            return false;
        }
        return true;
    };

    // 禁止滚动条滚动
    Vue.prototype.unScroll = function(){
        var top = $(document).scrollTop();
        $(document).on('scroll.unable',function (e) {
            $(document).scrollTop(top);
        });
    };

    // 移除禁止滚动条滚动
    Vue.prototype.removeUnScroll = function(){
        $(document).unbind("scroll.unable");
    };

    // 检索埋点
    Vue.prototype.createUserLog = function(browser, params, remark){
        delete params.pager;
        this.$axios.post(this.Common.createUserLog, {
            appId: "history",
            userId: this.Common.userInfo.id,
            version: "1.0",
            token: this.getTokenFunc(),
            body: {
                context: browser,
                logDate: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                userAgent: navigator.userAgent,
                clientIP: sessionStorage.getItem("clientIP"),
                url: browser,
                params: JSON.stringify(params),
                method: "",
                remark: remark
            }
        }).then((res) => {
            
        })
        .catch((err) => {
            console.log(err)
        });
    };

    /**
     * 浏览历史
     * @param {Object} obj 
     */
    Vue.prototype.browseHistory = function(obj){
        this.$axios.post(this.Common.favoritesCreateResource, {
            appId: "history",
            userId: this.Common.userInfo.id,
            version: "1.0",
            token: this.getTokenFunc(),
            body: {
                title   : obj.title    ? obj.title:'',
                subTitle: obj.subTitle ? obj.subTitle:'',
                content : obj.content  ? obj.content:'',
                author  : this.Common.userInfo.userName,
                releaseDate: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                image: obj.image ? obj.image:'',
                url  : obj.url   ? obj.url:'',
                releaseType: obj.releaseType ? obj.releaseType:'',
                sourceType: {
                    "id"  : obj.sourceType&&obj.sourceType.id   ? obj.sourceType.id:'',
                    "name": obj.sourceType&&obj.sourceType.name ? obj.sourceType.name:'',
                },
                dataType: {
                    "id"  : obj.dataType&&obj.dataType.id   ? obj.dataType.id:'',
                    "name": obj.dataType&&obj.dataType.name ? obj.dataType.name:'',
                },
                source: {
                    "id"  : obj.source&&obj.source.id   ? obj.source.id:'',
                    "name": obj.source&&obj.source.name ? obj.source.name:'',
                }
            }
        }).then((res) => {
            
        })
        .catch((err) => {
            console.log(err)
        });
    };

    // 取消收藏
    Vue.prototype.collectHandle = function(uri, title){
        this.$axios.post(this.Common.collectHandle, {
            appId: "history",
            userId: this.Common.userInfo.id,
            version: "1.0",
            token: this.getTokenFunc(),
            body: {
                handle: "D",
                resourceCode: uri,
                title: title
            }
        }).then((res) => {
            if(res.data.resultCode === "0000") {
                this.$message.success("已取消收藏");
            } else {
                this.$message.error(res.data.message);
            }
        })
        .catch((err) => {
            console.log(err)
        });
    };

    // 添加收藏
    Vue.prototype.createCollect = function(uri, title, prefix, year, week, favoritesId){
        this.$axios.post(this.Common.createCollect, {
            appId: "history",
            userId: this.Common.userInfo.id,
            version: "1.0",
            token: this.getTokenFunc(),
            body: {
                favoritesId: favoritesId,
                resourceCode: uri,
                title: title,
                pageUrl: prefix+uri+"&manifestsKey="+year+week
            }
        }).then((res) => {
            if(res.data.resultCode === "0000") {
                this.$message.success("已添加收藏");
            } else {
                this.$message.error(res.data.message);
            }
        })
        .catch((err) => {
            console.log(err)
        });
    };

    /**
     * 检索框提示和检索历史设置
     * @param {Object} _ret 检索框提示
     * @param {Object} _his 检索历史
     * @param {Object} _ord 历史拖拽顺序
     */
    Vue.prototype.hisRetAndOrdSetting = function(_ret, _his, _ord){
        this.$axios.post( this.Common.settingHandleUrl, {
            "appId"  : "history",
            "userId" : this.Common.userInfo.id,
            "version": "1.0",
            "token"  : this.getTokenFunc(),
            "body"   : {
                "retrieval": _ret,
                "history"  : _his,
                "orders"   : _ord
            }
        })
        .then((res) => {
            let resultData = res.data;
            console.log(resultData.message);
        })
        .catch((err) => {
            console.log(err);
        });
    };

    /**
     * 检索框提示设置
     */
    Vue.prototype.retrievalSetting = function(){
        // 检索框提示埋点START
        if(this.Common.userInfo) {
            let _retrieval = {
                "content": JSON.stringify([ '李鸿章', '张恨水', '鲁迅', '严独鹤', '啼笑因缘' ])
            }
            this.hisRetAndOrdSetting(_retrieval, null, null);
        }
        // 检索框提示埋点END
    };

    /**
     * 获取检索框提示和检索历史
     * @param {Vue} _this 
     */
    Vue.prototype.getHisAndRetSearch = function(_this){
        this.$axios.post( this.Common.searchSettingUrl, {
            "appId"  : "history",
            "userId" : this.Common.userInfo.id,
            "version": "1.0",
            "token"  : this.getTokenFunc(),
            "body"   : {}
        })
        .then((res) => {
            let resultData = res.data;
            let _body = resultData.body;
            _this.dataSourceHint = [];
            for(var index in _body){
                let obj = _body[index];
                
                // 检索框提示
                let _retObj     = {};
                let _retContent = obj.retrieval.content;
                let _retDisplay = obj.retrieval.display;
                if ( !_this.isEmpty(_retDisplay) ) _retDisplay = _retDisplay.toUpperCase(); // 转换大写
                if( !_this.isEmpty(_retContent) && _retDisplay === 'Y') { // && _retContent.indexOf('、') != -1
                    _retObj.title    = '检索框提示';
                    _retObj.children = JSON.parse(_retContent);
                    _this.dataSourceHint.push(_retObj);
                }
                
                // 检索历史
                let _hisContent = obj.history.content;
                let _hisDisplay = obj.history.display;
                if ( !_this.isEmpty(_hisDisplay) ) _hisDisplay = _hisDisplay.toUpperCase(); // 转换大写
                if( !_this.isEmpty(_hisContent) && _hisDisplay === 'Y' ) {
                    let _hisObj      = {};
                    let _params      = JSON.parse(_hisContent);
                    _hisObj.title    = '检索历史';
                    _hisObj.children = [_params.freetext];
                    if(!_this.isEmpty(_params.freetext)) _this.dataSourceHint.push(_hisObj);
                }
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };

    // 删除数组中的元素(改变原数组)
    Vue.prototype.removeArray = function(arr, val){
        var a = arr.indexOf(val); 
        if (a >= 0) { 
            arr.splice(a, 1); 
            return true;
        } 
        return false;  
    };

    // 删除数组中的元素(不改变原数组)
    Vue.prototype.removeArray2 = function(arr, val){
        let array = [];
        $.each(arr, (index, item)=>{
            if(item != val){
                array.push(item);
            }
        })
        return array;
    };

    // 判断图片url是否有效
    Vue.prototype.isImageUsable = function(imgurl) {
        return new Promise(function(resolve, reject) {
            let ImgObj = new Image(); //判断图片是否存在
            ImgObj.src = imgurl;
            ImgObj.onload = function(res) {
                resolve(res);
            };
            ImgObj.onerror = function(err) {
                reject(err);
            };
        }).catch((e) => {}); // 加上这句不会报错（Uncaught (in promise)）
    };

    /**
     * 数组去重
     * @param {Array} arr 原数组
     * @param {*} sortRules 排序规则，可传值：null
     */
    Vue.prototype.unique = function(arr, sortRules) {
        let formArr = sortRules != null ? arr.sort(sortRules) : arr.sort();
        let newArr = [formArr[0]];
        for (let i = 1; i < formArr.length; i++) {
            if (formArr[i]!==formArr[i-1]) {
                newArr.push(formArr[i]);
            }
        }
        return newArr;
    };

    /**
     * 数组对象去重后转为字符串
     * @param {Array} array 原数组
     * @param {String} prop 需要获取的数组对象中属性（key）,可有多个属性，用.隔开，例"person.name"
     * @param {String} separator 转化为字符串后的分隔符
     */
    Vue.prototype.listUniqToString = function(array, prop, separator){
        let arr = [];
        if( !this.isEmptyArray(array) ) {
            let _index = prop.indexOf('.');
            let _prop  = _index != -1 ? prop.split('.') : prop;
            for(let i=0; i<array.length; i++){
                if(_index != -1 && array[i][_prop[0]]) arr.push(array[i][_prop[0]][_prop[1]]); 
                else arr.push(array[i][_prop]);
            }
            arr = this.unique(arr, null); // 去重
        }
        return arr.join(separator);
    };

    /**
     * 数组对象转为字符串（不去重）
     * @param {Array} array 原数组
     * @param {String} prop 需要获取的数组对象中属性（key）,可有多个属性，用.隔开，例"person.name"
     * @param {String} separator 转化为字符串后的分隔符
     */
    Vue.prototype.arrayToString = function(array, prop, separator){
        let arr = [];
        if( !this.isEmptyArray(array) ) {
            let _index = prop.indexOf('.');
            let _prop  = _index != -1 ? prop.split('.') : prop;
            for(let i=0; i<array.length; i++){
                if(_index != -1 && array[i][_prop[0]]) arr.push(array[i][_prop[0]][_prop[1]]); 
                else arr.push(array[i][_prop]);
            }
        }
        return arr.join(separator);
    };

    /**
     * 获取数组内容并转换字符串(取数组中包含数组的属性，人名专用)
     * @param {Array} array 原数组
     * @param {String} prop 需要获取的数组对象中属性（key）,可有多个属性，用.隔开，例"person.nameChs.@id"
     * @param {String} separator 转化为字符串后的分隔符
     */
    Vue.prototype.arrToString = function(array, prop, separator){
        let arr = [];
        if( !this.isEmptyArray(array) ) {
            let _index = prop.indexOf('.');
            let _prop  = _index != -1 ? prop.split('.') : prop;
            for(let i=0; i<array.length; i++){
                let _array = array[i];
                if(_index != -1 && _array[_prop[0]]) {
                    _array[_prop[0]].forEach((p)=>{
                        let str = _prop[2] && _array[_prop[2]].indexOf('/bk/') == -1 ? 
                                '<a href="'+_array[_prop[2]]+'" target="_blank">'+p[_prop[1]]+'</a>' : p[_prop[1]];
                        arr.push(str);
                    });
                }
                else arr.push(_array[_prop]);
            }
        }
        return arr.join(separator);
    };

    /**
     * 删除数组中某个对象属性为空的
     * @param {Array} arr 原数组
     * @param {String} prop 某个对象中的属性（key）
     */
    Vue.prototype.removePropEmpty = function(arr, prop){
        let _arr = [];
        for(let i=0; i<arr.length; i++){
            if( !this.isEmpty(arr[i][prop]) ) _arr.push(arr[i]);
        }
        return _arr;
    };

    /**
     * 监听esc按键
     * @param {*} _this vue组件中this
     * @param {Number} index 大数据平台和报刊页面区分，0：大数据平台，1：报刊
     */
    Vue.prototype.esc = function(_this, index){
        document.addEventListener('keyup', (e)=>{
            if (e.defaultPrevented) {
                return; // 如果已取消默认操作，则不应执行任何操作
            }
            let code = null;
            let handled = false;
            if (e.key !== undefined) {
                code = e.key;
            } else if (e.keyIdentifier !== undefined) {
                code = e.keyIdentifier;
            } else if (e.keyCode !== undefined) {
                code = e.keyCode;
            }
            // esc键操作
            if ( (code == 'Escape' || code == 27) && _this.visible) {
                switch (index) {
                    case 0: // 大数据平台esc事件
                        if(_this.childTabIndex < 5) _this.hideSearch();
                        break;
                    case 1: // 报刊esc事件
                        _this.advHideSearch();
                        break;
                    default:
                        break;
                }
                handled = true;
            }
            
            if (handled) {
                // 如果事件已处理，则禁止“双重操作”
                e.preventDefault();
            }
        }, true);
    };

    /**
     * 导出CSV格式文件
     * @param {Array} title 文件内容标题
     * @param {Array} data 文件内容
     * @param {String} fileName 文件名
     */
    Vue.prototype.JSONToExcelConvertor = function(title, data, fileName) {
        let CSV = '';
        let row = "";

        for (let i = 0; i < title.length; i++) {
            if(title[i].title){
                row += title[i].title + ',';
            }
        }
        row = row.slice(0, -1);
        CSV += row + '\r\n';

        for (let i = 0; i < data.length; i++) {
            let row = "";
            for (let j = 0; j < title.length; j++) {
                if(title[j].title){
                    row += '"' + (data[i][title[j].field] ? data[i][title[j].field] : "") + '"\t,';
                }
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }

        if (CSV == '') {
            alert("Invalid data");
            return;
        }

        let uri = new Blob(['\ufeff' + CSV], {type:"text/csv,charset=utf-8"});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // 兼容 IE
            window.navigator.msSaveOrOpenBlob(CSV, fileName + ".csv");
        } 
        else { // 兼容 Non-IE（chrome、firefox etc.）
            let link = document.createElement("a");
            link.href = URL.createObjectURL(uri);
            link.style = "visibility:hidden";
            link.download = fileName + ".csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    /**
     * iiif页面，R按钮点击跳转
     * @param {Vue} _this 当前项目
     */
    Vue.prototype.iiifR = function(_this){
        let rBrn = null;
        let intervalRCount = 0;
        let iiifRTimer = setInterval(() => {
            // 超过10次还没有获取到按钮或者已经获取到按钮，则停止获取 if( _iiifRFlag )
            if( intervalRCount > 10 ) clearInterval(iiifRTimer);
            intervalRCount += 1;
            rBrn = document.getElementsByTagName('iframe')[0].contentWindow.document.getElementsByClassName("login btn imageBtn")[0];
            // if( !rBrn || (rBrn && !rBrn.firstElementChild) ) return false;
            if( rBrn && rBrn.firstElementChild ) {
                rBrn.firstElementChild.onclick = ()=>{
                    let _token = _this.getTokenFunc();
                    if( _this.isEmpty(_token) ) _this.$message.warning('请您先登录！', 1);
                    else {
                        // let _durl    = "https://dhc.library.sh.cn/sas/admin/home.jsp";
                        let _durl    = "https://dhc.library.sh.cn/sas/admin/manifests.jsp";
                        let _openUrl = _durl+'?token='+_token;
                        window.open(_openUrl);
                    }
                };
            }
            // return true;
        }, 100);
    };

    /**
     * 监听iframe中所有点击事件
     * @param {Vue} _this 当前项目
     */
    Vue.prototype.onListenerAllClick = function(_this){
        let getIiifRCount = 0;
        let getIiifRTimer = setInterval(() => {
            if( getIiifRCount > 10 ) clearInterval(getIiifRTimer);
            getIiifRCount += 1;
            window.frames[0].document.onclick = (e)=>{
                // R图标事件重写
                _this.iiifR(_this);
            };
        }, 100);
    };
    
    /**
     * 报人关系 或 关系图谱
     * @param {String} uri 
     * @param {String} from 来源（大数据平台、报刊库）
     */
    Vue.prototype.onRelation = function(uri, from){
        if(this.isEmpty(uri)) return;
        if( !this.isEmpty(from) && from == 'bk' ) localStorage.RELATION_FROM = from;
        else localStorage.removeItem("RELATION_FROM");
        // localStorage.RELATION_URI = uri;

        // 新页面打开链接
        let params = { uri: uri, from: from };
        if( this.isEmpty(from) || from != 'bk') delete params.from;
        let newUrl = this.$router.resolve({ path: '/relation', query: params });
        window.open(newUrl.href, '_blank');
        // window.open('https://dhc.library.sh.cn/uc/relation.html?uri=http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc&from=bk&token='+ this.getTokenFunc());
    };
    /**
     * 红色报人 新场景 chenss 20230726
     * @param {String} uri 
     * @param {String} from 来源（大数据平台、报刊库）
     */
    Vue.prototype.onRelationHSBR = function(uri, from){
        if(this.isEmpty(uri)) return;
        if( !this.isEmpty(from) && from == 'bk' ) localStorage.RELATION_FROM = from;
        else localStorage.removeItem("RELATION_FROM");
        // localStorage.RELATION_URI = uri;

        // 新页面打开链接
        let params = { uri: uri, from: from };
        if( this.isEmpty(from) || from != 'bk') delete params.from;
        let newUrl = this.$router.resolve({ path: '/relation3', query: params });
        window.open(newUrl.href, '_blank');
        // window.open('https://dhc.library.sh.cn/uc/relation.html?uri=http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc&from=bk&token='+ this.getTokenFunc());
    };
};